import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AdminMobileNav } from "@/components/admin/admin-mobile-nav";

export const Route = createFileRoute("/_authenticated/subcontractors")({
  beforeLoad: ({ context }) => {
    const user = (context as { user?: { role?: string | null } }).user;
    // Subcontractors and contractors never see this page. Admins, division admins and
    // project foremen do; the server limits what each of them can see.
    if (["subcontractor", "contractor"].includes(user?.role || "")) {
      throw redirect({ to: "/" });
    }
  },
  component: SubcontractorLayout,
});

function SubcontractorLayout() {
  const { user } = Route.useRouteContext();
  // Admins reach this page from the Admin list, so on a phone they keep that list at the top
  const adminNav = user?.role === "admin" || user?.role === "div_admin";
  return (
    <div className="space-y-4 max-w-5xl mx-auto px-4">
      {adminNav && <AdminMobileNav userId={user?.id} isSuperAdmin={user?.role === "admin"} />}
      <h1 className={adminNav ? "hidden text-2xl font-bold text-text-primary pt-2 md:block" : "text-2xl font-bold text-text-primary pt-2"}>Subcontractors</h1>
      <Outlet />
    </div>
  );
}
